/* @importstatement:
     import * as dompack from 'dompack';

   This function is our public api. Any direct inclusions from src/.... not mentioned here are not a stable API
*/

export { createDeferred } from './promise';
export { flagUIBusy } from './busy';
export { dispatchCustomEvent, fireModifiedEvents, navigateTo, changeValue, normalizeKeyboardEventData
       , allowEventProcessing } from './events';
export { contains, closest, matches, create, jsxcreate
       , replace, empty, onDomReady, getJSONAttribute
       , before, after, replaceWith, remove, prepend, append
       , toggleClasses
       , getBaseURI } from './tree';
export { focusElement, register, registerMissed } from './components';
export { debugflags, parseDebugURL, addDebugFlags } from './debug';



// WEBPACK FOOTER //
// /opt/wh/whtree/~/dompack/src/index.es